import React,{useState,useEffect} from 'react'
import { Button, Timeline } from 'flowbite-react';
import axios from 'axios'
import { HiAcademicCap } from 'react-icons/hi';
export default function PortfolioExperience({user_id}) {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(
      [
        {
            "exp_id": 53,
            "user_id": 3,
            "company": "Uniliver Ltd",
            "title": "Office Secretary",
            "duration": "2021-2022",
            "company_bangla": "ইউনিলিভার লি",
            "title_bangla": "দপ্তর সম্পাদক",
            "duration_bangla": "2021-2022"
        },
        {
            "exp_id": 54,
            "user_id": 3,
            "company": "Nagad Ltd",
            "title": "Office Secretary",
            "duration": "2022-Current",
            "company_bangla": "নগদ লি",
            "title_bangla": "দপ্তর সম্পাদক",
            "duration_bangla": "2022-বর্তমান"
        }
    ]
    )
    const [lan, setLan] = useState('bangla')
    const baseURL = "https://mukti-backend-bd.onrender.com"
    const getData = async () => {
        try {
            // const res = await axios.get(`${baseURL}/exp/${user_id}`)
            // console.log(res.data)
            // setData(res.data)
            setLoading(false)
        } catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        if (localStorage.getItem('language') === 'english') {
            setLan('english')
        } else {
            setLan('bangla')
        }
        getData()
    }, [])
  return (
    <Timeline horizontal>
     {data.map(a=>(
        <Timeline.Item>
        <Timeline.Point icon={HiAcademicCap} />
        <Timeline.Content>
          <Timeline.Time>
            {lan=="bangla"?a.duration_bangla:a.duration}
          </Timeline.Time>
          <Timeline.Title>
          {lan=="bangla"?a.title_bangla:a.title}
          </Timeline.Title>
          <Timeline.Body>
            <p>
                {lan=="bangla"?a.company_bangla:a.company}
            </p>
          </Timeline.Body>
        </Timeline.Content>
      </Timeline.Item>
     )) }
      </Timeline>
  )
}
